export default "__VITE_ASSET__DoyBOCHr__"